import Color from 'colorjs.io';
import { css } from 'styled-components';
import type { HexOrRgbColorString } from '@frameio/vapor';

const shadow = (width: string) => css`
  content: '';
  height: 100%;
  position: absolute;
  top: 0;
  width: ${width};
`;

const shadowColor = '#2b2d3d'; // the jobcard has a hover color of theme.colors.background.interactive.hover for the background. This translates to a color with an alpha channel. The shadow is to blend in with this background, so here we are just using a hard coded value of the vapor interactive hover.

function adjustAlpha({
  color,
  alpha,
}: {
  color: HexOrRgbColorString;
  alpha: number;
}) {
  const colorSRGB = new Color(color);
  colorSRGB.alpha = alpha;
  return colorSRGB.toString();
}

export const fadeOutLeftShadow = (width = '32px') => css`
  ${shadow(width)};
  background: linear-gradient(
    90deg,
    ${adjustAlpha({ color: shadowColor, alpha: 1 })} 0%,
    ${adjustAlpha({ color: shadowColor, alpha: 0.5 })} 50%,
    ${adjustAlpha({ color: shadowColor, alpha: 0 })} 100%
  );
  left: 0;
`;

export const fadeInLeftShadow = (width = '32px') => css`
  ${shadow(width)};
  background: linear-gradient(
    90deg,
    ${adjustAlpha({ color: shadowColor, alpha: 0 })} 0%
      ${adjustAlpha({ color: shadowColor, alpha: 0.5 })} 50%,
    ${adjustAlpha({ color: shadowColor, alpha: 1 })} 100%
  );
  right: 0;
`;
